import React from 'react';
import PropTypes from 'prop-types';
import ColorPicker from 'components/common/ColorPicker';
import FormGroup from './FormGroup';
import renderBlockErrors from './renderBlockErrors';


const BackgroundColorField = ({ errors, value, onChange }) => {
  const handleChange = val => onChange({ backgroundColor: val });
  const renderedErrors = renderBlockErrors(errors);

  return (
    <FormGroup label="Background:">
      <ColorPicker
        value={value}
        clearable
        onChange={handleChange}
      />
      {renderedErrors.backgroundColor}
    </FormGroup>
  );
};

BackgroundColorField.propTypes = {
  errors: PropTypes.object,
  value: PropTypes.string,
  onChange: PropTypes.func,
};

export default BackgroundColorField;
